<template>
  <div class="pm-dialog-head-count">

    <div class="flex justify-center">
      <div class="flex items-center justify-center pm-dialog-head-count-input" :class="[ headCountStrings.length > 0 ? 'input-any' : 'input-null' ]">
        <div class="head-count-input-area">
          <span v-for="( headCount, index ) in headCountStrings" :key="index">
            <span :style="{ color: colorCode(colorIds[index]) }" class="head-count-literal">{{ headCount }}</span>
          </span>
        </div>
      </div>
    </div>
    <div class="flex justify-center pen-list-area">
      <div v-for="(color,index) in colorsList" :key="index" @mousedown="onKeyDownColor(color.id)" >
        <vs-chip class="pen-item" :color="selectedColorId === color.id ? color.value.toUpperCase() === '#F2F2F2' ? 'black' : color.value : 'gray'">
          <feather-icon icon="Edit2Icon" svgClasses="h-6 w-6" :style="{ color: selectedColorId === color.id ? '#F2F2F2' : color.value.toUpperCase() === '#F2F2F2' ? 'white' : color.value }" />
        </vs-chip>
      </div>
    </div>
    <div class="flex justify-center">
      <div class="vs-row flex justify-start head-count-list-width">
        <div class="vs-col candidate-list"  v-for="(master,index) in masterList" :key="index" @mousedown="onKeyDown(master.value)" >
          <vs-chip class="pm-input-key head-count-item" :style="inputColor" color="#828282"
            onMouseOut="this.style.background='#828282'" 
            onMouseOver="this.style.background='#346c88'"
          >
            {{ master.value }}
          </vs-chip>
        </div>
      </div>
    </div>

    <div class="flex justify-center">
      <div class="flex justify-end head-count-list-width">
        <vs-button 
          class="flex justify-center items-center clear-button"
          color="#828282"
          onMouseOut="this.style.background='#828282'" 
          onMouseOver="this.style.background='#346c88'"
          @mousedown="onClear"
        >クリア</vs-button>
      </div>
    </div>
    <div class="flex justify-center">
      <vs-button 
        :color="enableSave ? '#2d9cdb' : '#bdbdbd'"
        class="save-button"
        @mousedown="onSubmit(false)"
      >
        保存
      </vs-button>
      <vs-button
        :color="enableSave ? '#2d9cdb' : '#bdbdbd'"
        class="save-button"
        @mousedown="onSubmit(true)"
      >
        ハイライト保存
      </vs-button>
    </div>

  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
const { mapState } = createNamespacedHelpers("portMasterDestinationWork");

export default {
  props: {
    taskId:    { type: String, required: true },
    columnKey: { type: String, required: true },
    valueMap:  { required: true },
  },
  data() {
    return {
      headCountStrings: [],
      colorIds: [],
      selectedColorId: 0,
    };
  },
  watch: {
    taskId() {
      this.initData();
    },
    summaryDialogShowPopup() {
      if ( this.summaryDialogShowPopup === true ) {
        this.initData();
      }
    },
  },
  computed: {
    ...mapState({
      masterMap: state => state.masterMap,
      summaryDialogShowPopup:  state => state.summaryDialogShowPopup,
    }),
    masterList() {
      return this.masterMap['head_count'];
    },
    enableSave() {
      return true; // ( this.headCountStrings && this.headCountStrings.length > 0 )
    },
    colorsList() {
      return this.masterMap['head_count_colors'];
    },
    inputColor() {
      let colroHex = '#F2F2F2';
      let colorObj =  this.colorsList.find(x => x.id === this.selectedColorId );
      if ( colorObj ) {
        colroHex = colorObj.value;
      }
      return {'color':colroHex};
    },
  },
  methods: {
    initData() {
      this.headCountStrings = this.valueMap && this.valueMap.value ? JSON.parse(JSON.stringify(this.valueMap.value)) : [];
      this.colorIds = this.valueMap && this.valueMap.color_id ? JSON.parse(JSON.stringify(this.valueMap.color_id)) : [];
      this.selectedColorId = 0;
    },
    onKeyDown(key){
      this.headCountStrings.push(key);
      this.colorIds.push(this.selectedColorId);
    },
    onClear() {
      this.headCountStrings = [];
      this.colorIds = [];
      this.selectedColorId = 0;
    },
    onSubmit(isUpdateTimeStamp) {
      let mode = []
      if (isUpdateTimeStamp) mode.push("updateTimeStamp")
      const updateKeyValueMap = {};
      updateKeyValueMap[this.columnKey + "#value"   ] = this.headCountStrings;
      updateKeyValueMap[this.columnKey + "#color_id"] = this.colorIds;
      this.$emit('updateValue',this.taskId, updateKeyValueMap, mode);
    },
    onKeyDownColor(colorCode) {
      this.selectedColorId = colorCode;
    },
    colorCode(colorId){
      let colorObj = this.colorsList.find(color => color.id === colorId);
      return colorObj ? ( colorObj.value && colorObj.value.toUpperCase() === '#F2F2F2' ? '#09151c' : colorObj.value ) : null;
    },
  },
  mounted() {
    this.initData();
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/port-master/_variables.scss";
.pm-dialog-head-count {
  .pm-dialog-head-count-input {
    width:10rem;
    height:3rem;
  }
  .head-count-input-area {
    margin: 0.4rem;
    white-space: nowrap;
    overflow: hidden;
  }
  .head-count-list-width {
    width: 84%;
  }
  .pen-item {
    border-radius: 5px;
    padding-top: 0.4rem;
    padding-bottom: 0.4rem ;
    margin: 0 0.2rem;
  }
  .pen-list-area {
    margin-top: 1rem;
    margin-bottom: 0.4rem;
  }
  .candidate-list {
    margin:0.2rem;
    padding: 0rem;
    .con-vs-chip {
      border-radius:6px;
      height:3rem;
      font-size: 120%;
      min-width: 3rem;
    }
  }

  .clear-button {
    margin: 1rem;
    padding: 0.2rem 1rem;
    height: 2rem;
    width: 8rem;
  }
  .head-count-literal {
    margin:0 0.1rem;
    border-radius: 2%;
    font-size: 150% !important;
  }
  .input-any {
    background-color: $pm-white;
    border: 2px solid $pm-blue;
  }
  .input-null {
    background-color: $pm-light-gray;
    border: none;
  }
  .save-button {
    margin: 0 1rem;
    width: 30%
  }

}
</style>

